export const EMAIL_OTP_OPTION = 'EMAIL';
export const SMS_OTP_OPTION = 'SMS';
